module.exports = __webpack_public_path__ + "3b8041512bdd92feff253be574f81b0e.MP3";